import type { ButtonHTMLAttributes, PropsWithChildren } from 'react';
import { AppleLogo } from './AppleLogo';
import { GoogleLogo } from './GoogleLogo';
import { ProviderButton } from './SocialLoginButton.styles';

type Provider = 'apple' | 'google';

/*
 * Typed against the button half of `ButtonProps`, not by an omit on the whole
 * type. `ButtonProps` is a union of a button and an anchor, and a plain `Omit`
 * flattens the two together. This control is never a link.
 */
type Props = PropsWithChildren<{
  /** Which provider's button this is. Decides the glyph. */
  provider: Provider;
  loading?: boolean;
  disabled?: boolean;
}> &
  Omit<
    ButtonHTMLAttributes<HTMLButtonElement>,
    'disabled' | 'href' | 'rel' | 'target' | 'type'
  >;

const SocialLoginButton = ({ provider, children, ...rest }: Props) => (
  <ProviderButton
    type="button"
    variant="secondary"
    fullWidth
    icon={provider === 'apple' ? <AppleLogo /> : <GoogleLogo />}
    iconAlignment="left"
    {...rest}
  >
    {children}
  </ProviderButton>
);

export { SocialLoginButton };
export type { Provider as SocialLoginButtonProvider };
